export default {
  "root": "_root_1l9li_1",
  "--inset": "_--inset_1l9li_1",
  "--disabled-focus-ring": "_--disabled-focus-ring_1l9li_1",
  "--radius-inherit": "_--radius-inherit_1l9li_1",
  "--disabled": "_--disabled_1l9li_1",
  "--full-width": "_--full-width_1l9li_1"
};import "ni:sha-256;5ZAHQQI25WImYR5mgxXHTew2oGSa-eIR4654_ZEAkSA";